import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import webservice from '../common/Webservice';
import {footerNotice} from '../misc/Shared';
import Graph from "./Graph";

const propTypes = {
	currentCobiId:  PropTypes.number,

	currentTab:  PropTypes.string,

	currentYear:  PropTypes.number,

	draft: PropTypes.bool,
};

const defaultProps = {};

const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentTab: state.app.currentTab,
	currentYear: state.app.currentYear,
	draft: state.app.draft
});

class Performance extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			content: undefined,
			measures: [],
			graphs: []
		};

		this.setContent = this.setContent.bind(this);
		this.getContent = this.getContent.bind(this);

		this.getContent();
	}

	componentDidUpdate(prevProps) {
		if ((prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)){
			this.getContent();
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getContent() {
		this.props.draft ?
			webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent)
			: webservice.public.tab.content(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent);
	}

	setContent(data) {
		!this.isCancelled && this.setState({content: data.text.tabHtml, measures: data.measures, graphs: data.graphs});
	}

	render() {
		return (
			<div className={"fr-view"}>
				<div dangerouslySetInnerHTML={{__html: this.state.content}}/>
				{this.state.graphs.map(graph => graph.isActive && <Graph graph={graph} key={graph.graphId}/>)}
				{this.state.measures.map(measure => (
					<div key={measure.performanceId}>
						<h3>{measure.performanceName}</h3>
						<div dangerouslySetInnerHTML={{__html: measure.performanceText}}/>
					</div>
				))}
				{footerNotice()}
			</div>
		);
	}
}

Performance.propTypes = propTypes;
Performance.defaultProps = defaultProps;

export default connect(mapStateToProps)(Performance);
